<template>
  <div>
    <h5 class="info-text"> Let's start with the basic information about the Event</h5>

    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="row justify-content-center">

          <div class="col-sm-4">
            <fg-input required
                      type="text"
                      name="title"
                      label="Title"
                      v-model="model.title"
                      v-validate="modelValidations.title"
                      :error="getError('title')">
            </fg-input>
          </div>

          <div class="col-sm-4">
            <fg-input required
                      type="text"
                      name="description"
                      label="Description"
                      v-model="model.description"
                      v-validate="modelValidations.description"
                      :error="getError('description')">
            </fg-input>
          </div>

          <div class="col-sm-2">
            <fg-input
                type="number"
                required
                name="price"
                label="Price"
                v-validate="modelValidations.price"
                :error="getError('price')"
                v-model="model.price">
            </fg-input>
          </div>

          <div class="col-sm-2">
            <fg-input required
                      type="text"
                      name="venue"
                      label="Venue"
                      v-model="model.venue"
                      v-validate="modelValidations.venue"
                      :error="getError('venue')">
            </fg-input>
          </div>

          <div class="col-sm-3">
              <fg-input
                  type="text"
                  required
                  name="department"
                  label="Department"
                  v-validate="modelValidations.department"
                  :error="getError('department')"
                  v-model="model.department">
                  <el-select class="select-primary" placeholder="Select Department" v-model="model.department" clearable filterable>
                      <el-option v-for="(option, index) in departments" class="select-primary" :value="option" :label="option" :key="index">
                      </el-option>
                  </el-select>
              </fg-input>
          </div>

          <div class="col-sm-3">
          <fg-input
              type="text"
              name="paper"
              label="Coourse"
              v-validate="modelValidations.paper"
              :error="getError('paper')"
              v-model="model.paper">
              <el-select class="select-primary" placeholder="Select Course" v-model="model.paper" filterable clearable value-key="slug" @change="handlePaperChange">
                  <el-option v-for="(option, index) in papers" class="select-primary" :value="option.slug" :label="`${option.code} - ${option.title}`" :key="index">
                  </el-option>
              </el-select>
          </fg-input>
      </div>

          <div class="col-sm-2">
            <fg-input
                v-if="login"
                type="text"
                required
                name="login"
                label="Auth ?"
                v-validate="modelValidations.login"
                :error="getError('login')"
                v-model="model.login">
                <n-switch v-model="model.login" on-text="True" off-text="False"></n-switch>
            </fg-input>
          </div>

          <div class="col-sm-2">
            <fg-input
                type="text"
                required
                name="visible"
                label="Visible ?"
                v-validate="modelValidations.visible"
                :error="getError('visible')"
                v-model="model.visible">
                <n-switch v-model="model.visible" on-text="True" off-text="False"></n-switch>
            </fg-input>
          </div>

          <div class="col-sm-2">
            <fg-input
                type="text"
                required
                name="multipleEntry"
                label="Multiple Entry?"
                v-validate="modelValidations.multipleEntry"
                :error="getError('multipleEntry')"
                v-model="model.multipleEntry">
                <n-switch v-model="model.multipleEntry" on-text="True" off-text="False"></n-switch>
            </fg-input>
          </div>

          <div class="col-sm-3">
              <fg-input
                  type="date"
                  name="open_date"
                  label="Open Date"
                  v-validate="modelValidations.open_date"
                  :error="getError('open_date')"
                  v-model="model.open_date">
                  <el-date-picker 
                      v-model="model.open_date" 
                      type="datetime" 
                      placeholder="Open Date">
                  </el-date-picker>
              </fg-input>
          </div>

          <div class="col-sm-3">
              <fg-input
                  type="date"
                  name="close_date"
                  label="Close Date"
                  v-validate="modelValidations.close_date"
                  :error="getError('close_date')"
                  v-model="model.close_date">
                  <el-date-picker 
                      v-model="model.close_date" 
                      type="datetime" 
                      placeholder="Close Date">
                  </el-date-picker>
              </fg-input>
          </div>

          <div class="col-sm-3">
              <fg-input
                  type="date"
                  name="start_date"
                  label="Start Date"
                  v-validate="modelValidations.start_date"
                  :error="getError('start_date')"
                  v-model="model.start_date">
                  <el-date-picker 
                      v-model="model.start_date" 
                      type="datetime" 
                      placeholder="Start Date">
                  </el-date-picker>
              </fg-input>
          </div>

          <div class="col-sm-3">
              <fg-input
                  type="date"
                  name="end_date"
                  label="End Date"
                  v-validate="modelValidations.end_date"
                  :error="getError('end_date')"
                  v-model="model.end_date">
                  <el-date-picker 
                      v-model="model.end_date" 
                      type="datetime" 
                      placeholder="End Date">
                  </el-date-picker>
              </fg-input>
          </div>

          <div class="col-sm-3">
            <fg-input
                type="text"
                required
                name="max_seat"
                label="Max Registrations"
                v-validate="modelValidations.max_seat"
                :error="getError('max_seat')"
                v-model="model.seating.max_seat">
                <el-input-number v-model="model.seating.max_seat" size="medium" :min="1" :max="10000"></el-input-number>
            </fg-input>
          </div>

          <div class="col-sm-3">
            <fg-input
                type="text"
                required
                name="max_teams"
                label="Max Teams"
                v-validate="modelValidations.max_teams"
                :error="getError('max_teams')"
                v-model="model.max_teams">
                <el-input-number v-model="model.max_teams" size="medium" :min="1" :max="10000"></el-input-number>
            </fg-input>
          </div>

          <div class="col-sm-3">
            <fg-input
                type="text"
                required
                name="min_participants"
                label="Min Participants"
                v-validate="modelValidations.min_participants"
                :error="getError('min_participants')"
                v-model="model.min_participants">
                <el-input-number v-model="model.min_participants" size="medium" :min="1" :max="10000"></el-input-number>
            </fg-input>
          </div>

          <div class="col-sm-3">
            <fg-input
                type="text"
                required
                name="max_participants"
                label="Max Participants"
                v-validate="modelValidations.max_participants"
                :error="getError('max_participants')"
                v-model="model.max_participants">
                <el-input-number v-model="model.max_participants" size="medium" :min="1" :max="10000"></el-input-number>
            </fg-input>
          </div>

          <div class="col-sm-4">
            <label>Other</label>
            <n-button v-if="model.login" type="primary" round block @click.native="openModal('batches')">Add Batches {{ ( model.batches && model.batches.length > 0) ? `(${model.batches.length})` : '' }}</n-button>
            <n-button type="primary" round block @click.native="openModal('forms')">Add Forms {{ ( model.form && model.form.length > 0) ? `(${model.form.length})` : '' }}</n-button>
            <n-button type="primary" round block @click.native="openModal('coordinators')">Add Coordinators {{ ( model.coordinators && model.coordinators.length > 0) ? `(${model.coordinators.length})` : '' }}</n-button>
            <n-button type="primary" round block @click.native="openModal('email')">Add Email Content</n-button>
          </div>

          <div class="col-sm-8">
            <label>Cover Image</label>
            <el-upload
                ref="imageUploader"
                class="avatar-uploader"
                name="image"
                list-type="text"
                accept="image/jpeg,image/png"
                :data="{path: 'tukio/programmes/events/'}"
                :action="uploadURL"
                :headers="headers"
                :show-file-list="true"
                :on-success="handleAvatarSuccess"
                :before-remove="handleRemove"
                :before-upload="beforeAvatarUpload">
                <div v-if="model.image" class="avatar" :style="`background-image: url(${model.image})`"></div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          
          <div class="col-sm-6 mt-3">
            <n-button type="default" round block @click.native="clearEvent">Clear Event</n-button>
          </div>

          <div class="col-sm-6 mt-3">
            <n-button type="success" round block @click.native="addEvent">Add Event to List {{ ( model.events && model.events.length > 0) ? `(${model.events.length})` : '' }}</n-button>
          </div>
          

        </div>
      </div>
      <div class="col-md-4">
        <label v-if="events && events.length > 0">Events</label>
        <draggable 
          tag="ul" 
          :list="events" 
          class="events-list-group" 
          handle=".handle" 
          v-if="events && events.length > 0"
          @start="isDragging = true" 
          @end="isDragging = false"
          :animation="200"
          group="inputs"
          :disabled="false"
          ghostClass="ghost">
          <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
            <li class="events-list-group-item" v-for="(event) in events" :key="event.title">
              <div class="row event-pill">
                  <div class="col-sm-1">
                    <i class="fa fa-align-justify handle"></i>
                  </div>
                  <div class="col-sm-6">
                      <h6>{{ event.title }}<br><small>{{ event.department }}</small></h6>
                  </div>
                  <div class="col-sm-5 text-right">
                      <n-button style="margin-left: 5px" type="warning" size="sm" round icon simple @click.native="editInput(event)">
                          <i class="fa fa-pencil"></i>
                      </n-button>
                      <n-button style="margin-left: 5px" type="primary" size="sm" round icon simple @click.native="copyInput(event)">
                          <i class="now-ui-icons files_single-copy-04"></i>
                      </n-button>
                      <n-button style="margin-left: 5px" type="danger" size="sm" round icon simple @click.native="deleteInput(event)">
                          <i class="now-ui-icons ui-1_simple-remove"></i>
                      </n-button>
                  </div>
              </div>
            </li>
          </transition-group>
        </draggable>

        <!-- <div class="row justify-contents-center m-1 mb-4" v-if="events.length > 0">
          <label v-if="events.length > 0">Events</label>
          <div class="col-sm-12"  v-for="(event, index) in events" :key="index">
            <div class="row event-pill">
                <div class="col-sm-7">
                    <h6>{{ event.title }}<br><small>{{ event.department }}</small></h6>
                </div>
                <div class="col-sm-5 text-right">
                    <n-button style="margin-left: 5px" type="warning" size="sm" round icon simple @click.native="editInput(event)">
                        <i class="fa fa-pencil"></i>
                    </n-button>
                    <n-button style="margin-left: 5px" type="primary" size="sm" round icon simple @click.native="copyInput(event)">
                        <i class="now-ui-icons files_single-copy-04"></i>
                    </n-button>
                    <n-button style="margin-left: 5px" type="danger" size="sm" round icon simple @click.native="deleteInput(event)">
                        <i class="now-ui-icons ui-1_simple-remove"></i>
                    </n-button>
                </div>
            </div>
          </div>
        </div> -->

      </div>
    </div>

    <modal :show.sync="modals.batches" headerClasses="justify-content-center" footerClasses="justify-content-center" type="large">
        <h4 slot="header" class="title title-up">Select Batches</h4>
        <div class="row" v-if="batches">
            <div class="col-12">
                <el-transfer
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="Batches"
                    v-model="model.batches"
                    :titles="['Available', 'Selected']"
                    :data="batches">
                </el-transfer> 
            </div>
        </div>
    </modal>

    <modal :show.sync="modals.email" headerClasses="justify-content-center" footerClasses="justify-content-center" type="large">
        <h4 slot="header" class="title title-up">Add Custom Email Content</h4>
        <div class="row">
            <div class="col-12">
              <ckeditor :editor="editor" v-model="model.email_content" :config="editorConfig"></ckeditor>
            </div>
        </div>
    </modal>

    <el-drawer
      size="80%"
      direction="rtl"
      title="Create Custom Form"
      :z-index="9999999"
      :show-close="true"
      :append-to-body="true"
      :wrapper-closable="false"
      :close-on-press-escape="false"
      :visible.sync="modals.forms">
      <CustomForm @on-submit="gotForm" :pool="pool" :login="login" :forms="model.form" :label-assignment="!pool"></CustomForm>
    </el-drawer>

    <!-- <modal :show.sync="modals.coordinators" headerClasses="justify-content-center" footerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">Add Coordinators Form</h4>
        <div class="row">
            <div class="col-12">
                <CoordinatorsForm @on-submit="gotCoordinators"></CoordinatorsForm>
            </div>
        </div>
    </modal> -->

    <el-drawer
      size="80%"
      direction="rtl"
      title="Create Coordinators Form"
      :z-index="9999999"
      :show-close="true"
      :append-to-body="true"
      :wrapper-closable="false"
      :close-on-press-escape="false"
      :visible.sync="modals.coordinators">
      <CoordinatorsForm @on-submit="gotCoordinators" :cords="model.coordinators"></CoordinatorsForm>
    </el-drawer>

  </div>
</template>
<script>
import { Upload, Select, Option, Slider, DatePicker, Transfer, Drawer } from 'element-ui';
import { Switch, Modal, CustomForm, CoordinatorsForm } from "src/components";
import { mapGetters } from 'vuex';
import draggable from "vuedraggable";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  components: {
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Slider.name]: Slider,
    [Transfer.name]: Transfer,
    [DatePicker.name]: DatePicker,
    [Drawer.name]: Drawer,
    Modal,
    CustomForm,
    CoordinatorsForm,
    draggable
  },
  props: {
    batches: Array,
    login: Boolean,
    pool: Boolean,
    scope: String,
    events: {
      type: Array,
      default: null
    }
  },
  watch: {
    // events(eventsVal){
    //   eventsVal.forEach((event, index) => {
    //     let batches = []
    //     event.batches.forEach((batch, index) => {
    //         batches.push(this.batches.findIndex((item) => item == batch))
    //     })
    //     event.batches = batches
    //   })
    // },
    // batches(batchesVal){
    //   this.events.forEach((event, index) => {
    //     let batches = []
    //     event.batches.forEach((batch, index) => {
    //         batches.push(batchesVal.findIndex((item) => item == batch))
    //     })
    //     event.batches = batches
    //   })
    // }
  },
  computed: {
        ...mapGetters({
            departments: 'getDepartments',
            types: 'getProgrammeTypes',
            papers: 'getPapers',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences',
        }),
        transfer_data(){
            const data = [];
            if(this.batches)
                this.batches.forEach((batch, index) => {
                    data.push({
                        label: batch,
                        key: index
                    });
                });
            return data;
        },
        headers(){
            this.authTokens['content-type'] = 'multipart/form-data'
            let {token, refreshtoken} = this.authTokens
            return {token, refreshtoken};
        },
        uploadURL(){
            return `${process.env.VUE_APP_BASE_URL}/tukio/upload`
        }
  },
  mounted(){
    this.$store.dispatch('getDepartments');
    this.$store.dispatch('getProgrammeTypes');
    this.$store.dispatch('getPapers');
  },
  data() {
    return {
      isEditing: false,
      inputIndex: null,
      isDragging: false,
      model: {
        batches: [],
        title: '',
        description: '',
        department: '',
        image: '',
        login: false,
        visible: true,
        multipleEntry: false,
        max_teams: 1,
        min_participants: 1,
        max_participants: 1,
        open_date: null,
        close_date: null,
        start_date: null,
        end_date: null,
        price: 0,
        venue: null,
        seating: {
          max_seat: 500,
          limited: false,
          current_seat: 0
        },
        form: [],
        coordinators: [],
        paper: null,
        email_content: null
      },
      modelValidations: {
        multipleEntry: {
          required: true,
        },
        login: {
          required: true,
        },
        title: {
          required: true,
        },
        venue: {
          required: true,
        },
        description: {
          required: true,
        },
        department: {
          required: true,
        },
        visible: {
          required: true,
        },
        open_date: {
          required: true,
        },
        close_date: {
          required: true,
        },
        start_date: {
          required: true,
        },
        end_date: {
          required: true,
        },
        price: {
          required: true,
        },
        max_seat: {
          required: true,
        },
        max_teams: {
          required: true,
        },
        min_participants: {
          required: true,
        },
        max_participants: {
          required: true,
        },
        paper: {
          required: false,
        },
      },
      modals: {
        batches: false,
        forms: false,
        coordinators: false,
        email: false
      },
      editor: ClassicEditor,
      editorConfig: {
          // The configuration of the editor.
      },
    };
  },
  methods: {
    filterMethod(query, item) {
      if(item.label) 
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      else
        return null
    },
    editInput(event){
        if(this.isEditing){
          this.$notify({
              message: `You have not saved the '${this.model.title}' to the events list, all changes will be lost if not added to the list.`,
              icon: 'fa fa-bell',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'warning',
              timeout: 5000
          })
        }
        else{
          this.inputIndex = this.events.indexOf(event)
          this.model = Object.assign({}, event)
          this.deleteInput(event)
          this.isEditing = true
        }
    },
    copyInput(event){
      if(this.isEditing){
          this.$notify({
              message: `You have not saved the '${this.model.title}' to the events list, all changes will be lost if not added to the list.`,
              icon: 'fa fa-bell',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'warning',
              timeout: 5000
          })
      }
      else{
        this.isEditing = false
        this.model = JSON.parse(JSON.stringify(Object.assign({}, event)))
        this.model.form = JSON.parse(JSON.stringify(Object.assign([], event.form)))
        this.model.coordinators = JSON.parse(JSON.stringify(Object.assign([], event.coordinators)))
        this.model.slug = null
      }
    },
    deleteInput(event){
        this.isEditing = false
        this.events.splice(this.events.indexOf(event), 1)
    },
    handleRemove(file, fileList){
      this.model.image = null
    },
    handlePreview(file) {
      this.model.image = URL.createObjectURL(file.raw);
    },
    openModal(name){
      this.modals[name] = true
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    gotForm(form){
      this.model.form = form
      this.modals.forms = false
    },
    gotCoordinators(coordinators){
      this.model.coordinators = coordinators
      this.modals.coordinators = false
    },
    clearEvent(){
      this.model = {
        batches: [],
        title: '',
        description: '',
        department: null,
        image: null,
        login: false,
        visible: false,
        multipleEntry: true,
        max_teams: 1,
        min_participants: 1,
        max_participants: 1,
        open_date: null,
        close_date: null,
        start_date: null,
        end_date: null,
        price: 0,
        venue: null,
        seating: {
          max_seat: 500,
          limited: false,
          current_seat: 0
        },
        form: [],
        coordinators: [],
        paper: null
      }

      this.errors.clear();
      this.$nextTick(() => {
          this.$validator.reset();
      });

      this.isEditing = false
      this.inputIndex = null
      this.$refs.imageUploader.clearFiles();
    },
    addEvent(){
      return this.$validator.validateAll().then(isValid => {
      if(isValid){
          // let batches = []
          // this.model.batches.forEach((batch, index) => {
          //     batches.push(this.batches[batch])
          // })
          // this.model.batches = batches

          // this.model.seating = {
          //   limited: false,
          //   current_seat: 0,
          //   max_seat: this.model.max_seat
          // }
          if(!this.isEditing)
            this.events.push(Object.assign({}, this.model))
          else{
            this.events.splice(this.inputIndex, 0, this.model);
          }

          this.clearEvent();
        }
      });
    },
    validate() {
        // this.events.forEach((event, index) => {
        //   let batches = []
        //   event.batches.forEach((batch, index) => {
        //       batches.push(this.batches[batch])
        //   })
        //   event.batches = batches
        // })

        if(this.isEditing){
          this.$notify({
              message: `You have not saved the '${this.model.title}' to the events list, all changes will be lost if not added to the list.`,
              icon: 'fa fa-bell',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'warning',
              timeout: 5000
          })
          return false;
        }
        
        this.$emit('on-validated', true, { events: Object.assign([], this.events) } );
        return true;
    },
    handleAvatarSuccess(res, file) {
        this.model.image = res.data.image;
    },
    beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            this.$notify({
                message: `Cover picture size can not exceed 2MB!`,
                icon: 'fa fa-bell',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'danger'
            })
        }
        return isLt2M;
    },
    handlePaperChange(slug){
      let paper = this.papers.find((item) => item.slug === slug)
      if(paper){
        this.model.title       = paper.title
        this.model.description = `${paper.code} - ${paper.title}`
      }
      else{
        this.model.title       = ''
        this.model.description = ''
      }
    }
  }
};
</script>
<style lang="scss">
  .bootstrap-switch{
      display: block;
      width: 90px!important;
      height: 35px!important;

      &.bootstrap-switch-on{
          .bootstrap-switch-label{
              left: 70%;
          }
      }

      .bootstrap-switch-label{
          width: 35px!important;
          height: 35px!important;
      }

      .bootstrap-switch-handle-off,
      .bootstrap-switch-handle-on{
          font-weight: bold;
          line-height: 22px;
          text-indent: 10px;
          color: #273c75!important;
          width: 100%!important;
      }
      .bootstrap-switch-handle-off{
          text-indent: 15px;
      }
  }

  .el-transfer-panel__filter.el-input{
      width: 85%;
  }

  .events-list-group{
    list-style-type: none;
    padding: 10px;

    .events-list-group-item{
      .handle{
        padding-top: 10px;
      }
    }
  }

  .event-pill{
    padding-top: 5px;
    border-radius: 10px;
    margin-bottom: 10px;
    background: #fff;
    border: solid 1px #273c75;
    box-shadow: 0px 2px 3px #e7e7e7;

    .btn{
      margin: 0;
    }
  }
  .ck-editor__editable {
  min-height: 300px;
  }
</style>
